export default __webpack_public_path__ + "static/pic10-32c0662e19b43f149fd1aa7a1dd3fc97.jpg";